import React from 'react';

import {Modal, ModalHeader, ModalBody, ModalFooter} from 'Components/Modal';
import {PrimaryButton, SecondaryButton} from 'Components/Button';

import {translation} from 'Services/TranslationHelpers';

export default class CheckOverlapModal extends React.Component {
    /**
     * @method render
     * @return {JSX.Element}
     */
    render () {
        const {callbackOnSubmit, onClose} = this.props;

        return (
            <Modal>
                <ModalHeader onClose={onClose}>
                    Session Overlap
                </ModalHeader>

                <ModalBody>
                    There is another session running at this time, do you wish to continue?
                </ModalBody>

                <ModalFooter alignment="center">
                    <SecondaryButton 
                        text={translation('misc', 'cancel')} 
                        onClick={onClose}
                    />

                    <PrimaryButton 
                        text={translation('misc', 'submit')} 
                        onClick={() => {
                            callbackOnSubmit();
                            onClose();
                        }}
                    />
                </ModalFooter>
            </Modal>
        )
    }
};
